import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/layout/Layout";
import Home from "../pages/home/page";
import Works from "../pages/works/page";
import WorkDetail from "../pages/work-detail/page";
import About from "../pages/about/page";
import Faq from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/works", element: <Works /> },
      { path: "/work/:id", element: <WorkDetail /> },
      { path: "/about", element: <About /> },
      { path: "/faq", element: <Faq /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;